import React from 'react';
import { Link } from 'react-router-dom';
import './BackButton.css';

import { ArrowBack } from '@material-ui/icons';


const BackButton = ({ link, customClass, handleClick = () => {}, fontSize }) => (
  <Link
    className={`back-button ${customClass ? customClass : ''}`}
    style={{ fontSize }}
    to={link}
    onClick={handleClick}
  >
    <ArrowBack fontSize="inherit" />
  </Link>
);

export default BackButton;
